var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoirUserBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81407 9.5487C10.8666 9.5487 11.8761 9.13057 12.6204 8.3863C13.3646 7.64202 13.7828 6.63257 13.7828 5.58C13.7828 4.52743 13.3646 3.51798 12.6204 2.7737C11.8761 2.02943 10.8666 1.6113 9.81407 1.6113C8.7615 1.6113 7.75205 2.02943 7.00777 2.7737C6.2635 3.51798 5.84537 4.52743 5.84537 5.58C5.84537 6.63257 6.2635 7.64202 7.00777 8.3863C7.75205 9.13057 8.7615 9.5487 9.81407 9.5487V9.5487Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86884 16.4939C2.86885 15.1903 3.23577 13.913 3.92762 12.8081C4.61947 11.7032 5.60832 10.8154 6.78107 10.2461C7.95382 9.67676 9.26312 9.44902 10.5592 9.58889C11.8553 9.72876 13.0859 10.2306 14.1102 11.037",
    stroke: "#3C3C3C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5688 13.3191C15.3492 13.0995 15.0819 12.9333 14.7877 12.8336C14.4936 12.7338 14.1804 12.7031 13.8724 12.7438C13.5645 12.7845 13.27 12.8955 13.0119 13.0683C12.7537 13.241 12.5388 13.4709 12.3838 13.7401H9.59139L8.58113 14.7503L9.59139 15.7606L10.0965 15.2555L10.6017 15.7606L11.1068 15.2555L11.6119 15.7606H12.3865C12.4744 15.9145 12.5818 16.0556 12.7064 16.1816C13.086 16.5611 13.6008 16.7744 14.1376 16.7744C14.6744 16.7744 15.1892 16.5611 15.5688 16.1816C15.9484 15.802 16.1616 15.2871 16.1616 14.7503C16.1616 14.2135 15.9484 13.6987 15.5688 13.3191V13.3191Z",
    stroke: "#3C3C3C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4744 14.9187C14.5674 15.0117 14.7181 15.0117 14.8111 14.9187C14.9041 14.8257 14.9041 14.6749 14.8111 14.582C14.7181 14.489 14.5674 14.489 14.4744 14.582C14.3814 14.6749 14.3814 14.8257 14.4744 14.9187Z",
    fill: "#3C3C3C",
    stroke: "#3C3C3C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirUserBag);
export default __webpack_public_path__ + "static/media/iconoir_user-bag.396cc18946c7e175cd0e4bac02ed94f9.svg";
export { ForwardRef as ReactComponent };